export function getInitialChatName(): string {
  return `New Chat - ${new Date().toLocaleDateString()}`;
}
